import { useEffect, useRef, useState } from "react";
import axios from "../lib/axios";
import { ssoDone } from "../lib/sso";

const EMPTY = { loggedIn: false, storeId: null, username: null, storeName: null, isSuper: false,
  portalUrl: null, ssoStart: null, settingsChangedLabel: "-" };

export default function useStoreAdminAuth() {
  const [state, setState] = useState({ loading: true, ...EMPTY });
  const timerRef = useRef(null);

  useEffect(() => {
    let alive = true;
    const checkOnce = async () => {
      try {
        const { data } = await axios.get("/store-admin/check");
        if (!alive) return;
        if (data.logged_in) ssoDone();
        setState({ loading: false, loggedIn: !!data.logged_in, storeId: data.store_id ?? null, username: data.username ?? null,
          storeName: data.store_name ?? null, isSuper: !!data.is_super, portalUrl: data.portal_url ?? null,
          ssoStart: data.sso_start ?? null, settingsChangedLabel: data.settings_changed_label ?? "-" });
      } catch {
        // 한 번의 네트워크 실패로 로그아웃시키지 않는다: 첫 확인 실패만 로그아웃 상태로(결정 5)
        if (alive) setState((prev) => (prev.loading ? { loading: false, ...EMPTY } : prev));
      }
    };
    checkOnce();                                              // 최초 1회 즉시
    timerRef.current = setInterval(checkOnce, 10000);         // 권한 회수 감지용(기존과 같음)
    return () => {
      alive = false;
      if (timerRef.current) { clearInterval(timerRef.current); timerRef.current = null; }
    };
  }, []);

  return state;
}
